import { AntDesign } from "@expo/vector-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View, Pressable } from "react-native";

import TitleXl from "@/components/TitleXl";
import { generateDocxCustomerData } from "@/utils/management/ExportCustomerData";
import {
  renderObjectValues,
  renderInvestmentProfileObjectValues,
} from "@/utils/management/RenderObject";

interface GeneralInformationProps {
  data: any;
}

export default function GeneralInformation(props: GeneralInformationProps) {
  const { t } = useTranslation();

  const keysToIgnore = [
    "id",
    "createdAt",
    "status",
    "individuals",
    "registeredAddress",
    "physicalAddress",
    "kycProfile",
    "investmentProfile",
    "application",
    "counterParties",
    "accounts",
    "user",
    "documents",
  ];

  return (
    <View className="w-full flex-col items-center">
      <View className="w-full items-center my-4">
        <Pressable
          className="flex-row items-center mt-2"
          onPress={() => generateDocxCustomerData(props.data, t)}
        >
          <AntDesign name="download" size={24} color="#919191" />
          <Text className="ml-3 text-darkergray text-base">
            {t("common:placeholder.downloadcustomerdata")}
          </Text>
        </Pressable>
      </View>
      <View className="border border-gray rounded-lg p-4 w-full lg:w-4/5 shadow">
        <View className="w-full items-center">
          <TitleXl text={t("management/customer:information.title")} />
        </View>
        {renderObjectValues(props.data, keysToIgnore, t)}
      </View>
      {props.data.physicalAddress && (
        <View className="border border-gray rounded-lg p-4 mt-4 w-full lg:w-4/5 shadow">
          <View className="w-full items-center">
            <TitleXl
              text={t("management/customer:information.physicaladdress.title")}
            />
          </View>
          {renderObjectValues(props.data.physicalAddress, keysToIgnore, t)}
        </View>
      )}
      {props.data.registeredAddress && (
        <View className="border border-gray rounded-lg p-4 mt-4 w-full lg:w-4/5 shadow">
          <View className="w-full items-center">
            <TitleXl
              text={t(
                "management/customer:information.registeredaddress.title"
              )}
            />
          </View>
          {renderObjectValues(props.data.registeredAddress, keysToIgnore, t)}
        </View>
      )}
      {props.data.investmentProfile && (
        <View className="border border-gray rounded-lg p-4 mt-4 w-full lg:w-4/5 shadow">
          <TitleXl
            text={t("management/customer:information.investmentprofile.title")}
          />
          {renderInvestmentProfileObjectValues(
            props.data.investmentProfile,
            keysToIgnore,
            t
          )}
        </View>
      )}
      {props.data.kycProfile && (
        <View className="border border-gray rounded-lg p-4 h-fit mt-4 w-full lg:w-4/5 my-2 shadow">
          <TitleXl
            text={t("management/customer:information.kycprofile.title")}
          />
          {renderObjectValues(props.data.kycProfile, keysToIgnore, t)}
        </View>
      )}
    </View>
  );
}
